import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import supports from './supports';

function isNil(value) {
  return value == null;
}

const UserContext = createContext();

function UserProvider({ children }) {
  let [idle, setIdle] = useState(false);
  let [online, setOnline] = useState(true);
  let fragile = useRef(null);
  let emo = useRef(null);
  let enchanced = useRef(null);

  useEffect(() => {
    /* eslint-disable */
    document.addEventListener('visibilitychange', toggle, false);
    document.addEventListener('offline', toggleConnectivity);
    document.addEventListener('online', toggleConnectivity);

    return () => {
      document.removeEventListener('visibilitychange', toggle, false);
      document.removeEventListener('offline', toggleConnectivity);
      document.removeEventListener('online', toggleConnectivity);
    };
  });

  function toggle() {
    return setIdle(document.hidden);
  }

  function toggleConnectivity() {
    return setOnline(navigator.onLine);
  }

  useEffect(() => {
    if (isNil(fragile.current)) {
      fragile.current =
        window.matchMedia && matchMedia('(prefers-reduced-motion)').matches;
    }

    if (isNil(emo.current)) {
      emo.current =
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    if (isNil(enchanced.current)) {
      enchanced.current = supports();
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        idleUser: idle,
        fragileUser: fragile.current,
        emoUser: emo.current,
        enchancedBrowser: enchanced.current,
        userOnline: online,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a UserProvider`);
  }
  return context;
}

export { UserProvider, useUser };
